// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-dialog:has(.loader-card) {\n  border-radius: 50% !important;\n  max-height: 150px;\n  height: 100%;\n  overflow: hidden !important;\n}", ""]);
// Exports
module.exports = exports;
